export default {
  dear: {
    DealerName: '经销商名称',
    Region: '所属地区',
    Province: '省',
    City: '市',
    Status: '状态',
    ComeFrom: '来源',
    No: '序号',
    Code: '经销商编码',
    DealerType: '经销商类型',
    Mobile: '联系人手机',
    PriceLevel: '价格级别',
    CreateTime: '创建日期',
    ModifyTime: '修改日期',
    Salesman: '业务员',
    Operation: '操作',

    Linkman: '联系人姓名',
    Telephone: '电话号码',
    Birthday: '生日',
    Area: '区/县',
    ZipCode: '邮政编码',
    Address: '详细地址',
    Remark: '备注',
    AccountName: '打款户名',
    AccountBank: '打款开户银行',
    BankAccountNo: '打款银行账号',
    InitDue: '期初应付款',
    Due: '期初应收款',
    InitBalance: '期初余额',
    CreditLine: '信用额度',
    CautionMoney: '保证金',
    AnnualMission: '年度任务',
    LoginName: '账号',
    Password: '密码',
    OrderDiscount: '折扣',
    Edit: '编辑',
    ChooseDealer: '经销商选择'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/cmc/dealer.js